import styles from './Landing.module.css'

const Landing = ({ user }) => {
  return (
    <main className={styles.container}>
      <h1 className='title'>Footprint</h1>
    </main>
  )
}

export default Landing
